/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tags_AerialInputs */

const en_control_tags_aerial = /** @type {(inputs: Control_Tags_AerialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aerial`)
};

const zh_control_tags_aerial = /** @type {(inputs: Control_Tags_AerialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空中`)
};

/**
* | output |
* | --- |
* | "Aerial" |
*
* @param {Control_Tags_AerialInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tags_aerial = /** @type {((inputs?: Control_Tags_AerialInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tags_AerialInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tags_aerial(inputs)
	return zh_control_tags_aerial(inputs)
});
export { control_tags_aerial as "control.tags.aerial" }